export default __webpack_public_path__ + "static/media/SVGsetting.27d1c873.svg";